/* eslint-disable react-hooks/rules-of-hooks */
import React, { Fragment, useEffect, useState } from 'react';
import { Grid, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import { Helmet } from 'react-helmet-async';
import LeaveManagementView from './LeaveManagementView';
import LeaveManagementHrView from './LeaveManagementHrView';
import LeaveManagementRmView from './LeaveManagementRmView';
import { LeaveManagementActions } from 'src/store/LeaveManagementReducer';
import { useDispatch } from 'react-redux';

const LeaveManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [userRole, setUserRole] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isActivePM_RM, setIsActivePM_RM] = useState<boolean>(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (Object.keys(user).length === 0) {
      navigate('/');
    }
  }, [navigate]);

  
  useEffect(() => {
    const user = window.localStorage.getItem('user');
    const userModel = JSON.parse(user);
    setUserRole(userModel?.Roles);

    //check is Project manager or Reporting manager
    if ((userModel.IsProjectManager === true || userModel.IsProjectManager === 'true') 
        || (userModel.IsReportingManager === true || userModel.IsReportingManager === 'true')) {
      setIsActivePM_RM(true);
      dispatch(LeaveManagementActions.setIsReportingManager(true));
      setIsLoading(false);
    }else {
      dispatch(LeaveManagementActions.setIsReportingManager(false));
      setIsLoading(false);
    }
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>Leave Management</title>
      </Helmet>

      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          {!isLoading  && <Grid item xs={12}>
            {userRole.split(',').includes('Super User') || userRole.split(',').includes('HR Manager')
              || userRole.split(',').includes('Assistant HR Manager') || userRole.split(',').includes('HR Executive') ?
              <LeaveManagementHrView 
              userRole={userRole.split(',').includes('Super User') ? 'Super User' :
              userRole.split(',').includes('HR Manager') ? 'HR Manager' : 
              userRole.split(',').includes('Assistant HR Manager') ? 'Assistant HR Manager' :
              userRole.split(',').includes('HR Executive') && 'HR Executive'} /> :
              isActivePM_RM ?
                <LeaveManagementRmView userRole={'Reporting Manager'} /> :
                <LeaveManagementView userRole={userRole} />
            }
          </Grid>}
        </Grid>
        <SnackBar />
      </Container>
    </Fragment>
  );
};

export default LeaveManagement;
